import { isBefore } from "date-fns";

export function getHistoricalPropertyAtSnapshotDate(
  deal: any,
  propertyName: string,
  snapshotDate: Date | undefined,
  _shouldLog = false,
) {
  if (snapshotDate === undefined) return undefined;

  // Start by taking the deal's current property
  // Then look through the property history
  // It is sorted most-recent-first so keep updating until a date is reached in history
  // which is before the snapshotDate
  let value = deal.provider_data?.properties?.[propertyName] ?? undefined;

  const propertiesWithHistory = deal.provider_data?.propertiesWithHistory ?? [];
  const propertyHistory = propertiesWithHistory[propertyName] ?? [];

  for (const historyRecord of propertyHistory) {
    if (isBefore(historyRecord.timestamp, snapshotDate)) break;
    value = historyRecord.value;
  }

  return value;
}
